// extracted by mini-css-extract-plugin
module.exports = {"wrap":"rd","articleImagesWrap":"sd","articleImage":"td","singleImage":"ud"};